export class Receptor {
	receptorId: string;
	clienteId?: string;
	tieneDatosPropios?: boolean;
	guardarCambios?: boolean;
	rut?: number;
	rutString: string;
	razonSocial: string;
	nombreFantasia?: string;
	giro: string;
	dirPart: string;
	dirFact: string;
	correoPar: string;
	correoFact: string;
	ciudad: string;
	comuna: string;
	emisorId?: string;
	dv: string;
	activo: boolean;
	showActions?: boolean;
	domicilios?: Domicilio[]; 
}

export interface Domicilio {
    direccion: string;
    ciudad: string;
    comuna: string;
}
